import useMenuTaxonomyList from '@/hooks/useMenuTaxonomyList';
import { IMenuTaxonomy } from '@/@types/generated/contentful';

export type Query = {
  slug: IMenuTaxonomy['fields']['taxonomy'];
};

export default function useMenuTaxonomy(query: Query) {
  const menuTaxonomyList = useMenuTaxonomyList();
  const taxonomy = menuTaxonomyList.find((item) => item.fields.taxonomy === query.slug);
  const error =
    menuTaxonomyList === undefined ||
    !menuTaxonomyList.map((item) => item.fields.taxonomy).includes(query.slug);

  return [taxonomy, error] as const;
}
